<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import api from "@/api";
export default {
  data() {
    return {};
  },
  created() {
    console.log(process.env)
  }
};
</script>
<style lang="scss">
#app{
  height: 100%;
}

</style>
